import { Component, OnInit, Output } from '@angular/core';
import { ProjectService, FunctionTypeService, FunctionTypeContactService } from '../../../camtl.service';
import { Project, Contact } from '../../../../../shared/model';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-camtl-projects',
  templateUrl: './camtl-projects.component.html',
  // styleUrls: ['./camtl-projects.component.scss']
})
export class CamtlProjectsComponent implements OnInit {

  constructor(
    private ProjectService: ProjectService,
    private FunctionTypeService: FunctionTypeService,
    private FunctionTypeContactService: FunctionTypeContactService,
    private formBuilder: FormBuilder
  ) { }

  projectId: any;
  isNew: boolean = false;
  editDataItem: Project;
  editForm = new FormGroup({

    ProjectNumber: new FormControl("", Validators.required),
    Description: new FormControl("", Validators.required),
    PrimaryShopYear: new FormControl(0),
    ContactId: new FormControl("", Validators.required),
    BIWLaborAggregate: new FormControl(0, Validators.min(0)),
    BIWLaborRate: new FormControl(0, Validators.min(0)),
    BIWMatlAggregate: new FormControl(0, Validators.min(0)),
    OutsideLaborRate: new FormControl(0, Validators.min(0)),
    OutsideMatlAggreate: new FormControl(0, Validators.min(0)),
    MechDesignRate: new FormControl(0, Validators.min(0)),
    CCRWDescRate: new FormControl(0, Validators.min(0)),
    Active: new FormControl("", Validators.required),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),
  });


  columns: any[] = [{
    field: "ProjectNumber",
    title: "Project Number",
  }, {
    field: "Description",
    title: "Description"
  },
  {
    field: "PrimaryShopYear",
    title: "Primary Shop Year"
  },
  {
    field: "BIWLaborRate",
    title: "BIW Labor Rate"
  },
  {
    field: "OutsideLaborRate",
    title: "Outside Labor Rate"
  },
  {
    field: "OutsideMatlAggreate",
    title: "Outside Matl Aggreate"
  },
  {
    field: "CCRWDescRate",
    title: "CCRW Design Rate"
  },
  {
    field: 'ContactName',
    title: 'Contact Name'
  },
  {
    field: "Active",
    title: "Status",
    width: "125",
    template: {
      type: "boolean",
      onLabel: "Active",
      offLabel: "Inactive"
    }
  }]

  onRead = () => {
    return this.ProjectService.read("", true);
  }


  template = {
    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: true,
    },
    columns: this.columns,
    read: this.onRead,
    service: this.ProjectService,
    fileName: "projects.xlsx"
  }


  formDialog = {
    title: "Project",


    formControls: [{
      type: "text",
      name: "ProjectNumber",
      title: "Project Number",
      readonly: "never",
      width: 190
    }, {
      type: "text",
      name: "Description",
      title: "Description",
      readonly: "never",
      width: 190
    },
    {
      type: "number",
      readonly: "never",
      name: "PrimaryShopYear",
      title: "Primary Shop Year",
      minimum: "1992"

    },
    {
      type: "combobox",
      readonly: "never",
      name: "ContactId",
      title: "Contact",
      textField: 'LastName',
      valueField: 'ContactId',
      placeholder: 'Select Last Name...',
      service: this.FunctionTypeContactService,
    },
    {
      type: "number",
      name: "BIWLaborAggregate",
      title: "BIW Labor Aggregate",
      readonly: "never",
    }, {
      type: "number",
      name: "BIWLaborRate",
      title: "BIW Labor Rate",
      readonly: "never",
    },
    {
      type: "number",
      readonly: "never",
      name: "OutsideLaborRate",
      title: "Outside Labor Rate",
    },
    {
      type: "number",
      readonly: "never",
      name: "MechDesignRate",
      title: "Mech Design Rate",
    },
    {
      type: "number",
      readonly: "never",
      name: "BIWMatlAggregate",
      title: "BIW Matl Aggregate",
    },
    {
      type: "number",
      readonly: "never",
      name: "OutsideMatlAggreate",
      title: "Outside Matl Aggreate",
    },
    {
      type: "number",
      readonly: "never",
      name: "CCRWDescRate",
      title: "CCRW Design Rate",
    },
    {
      type: "boolean",
      name: "Active",
      title: "Active",
    }]
  }




  ngOnInit(): void {
    var self = this;

    this.FunctionTypeService.read("", true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        if (response[i].Description === "Project") {
          self.projectId = response[i].Id;
          return self.FunctionTypeContactService.read("/" + self.projectId + "?$filter=IsActive eq true", true);
        }
      }
    })

    // this.usageFormControl.formControls[0] = usage);
  }

  setModelHandler(): void {
    this.editDataItem = new Project();
    this.editDataItem.PrimaryShopYear = new Date().getFullYear();
    this.editDataItem.Active = false;
  }
}
